export type FeatureFlipping = {
    isDebugServerErrorEnabled: boolean;
    isSessionBridgeEnabled: boolean;
    isSessionBridgeDebugEnabled: boolean;
    isOutputLoggingEnabled: boolean;
    isTimeMachineEnabled: boolean;
    isOpentelemetryEnabled: boolean;
    isAppVersionEnabled: boolean;
    isReachFiveEnabled: boolean;
    isThemeSwitcherEnabled: boolean;
    isDiscoverBreadcrumbShortUrlsEnabled: boolean;
    isDeliveryToStoreCheckEnabled: boolean;
    isT2sConfigEnabled: boolean;
    isReorderProductsEnabled: boolean;
    isPathnameOnlyEnabled: boolean;
    isShopTheFutureCustomerGroupsEnabled: boolean;
    isLoyaltyConfigEnabled: boolean;
};

export const createFeatureFlipping = (): FeatureFlipping => {
    return {
        isDebugServerErrorEnabled: process.env['DEBUG_SERVER_ERROR_ENABLED'] === 'true',
        isSessionBridgeEnabled: process.env['SESSION_BRIDGE_ENABLED'] === 'true',
        isSessionBridgeDebugEnabled: process.env['SESSION_BRIDGE_DEBUG_ENABLED'] === 'true',
        isOutputLoggingEnabled: process.env['OUTPUT_LOGGING_ENABLED'] === 'true',
        isTimeMachineEnabled: process.env['TIME_MACHINE_ENABLED'] === 'true',
        isOpentelemetryEnabled: process.env['OPENTELEMETRY_ENABLED'] === 'true',
        isAppVersionEnabled: process.env['DISPLAY_APP_VERSION_ENABLED'] === 'true',
        isReachFiveEnabled: process.env['REACH_FIVE_ENABLED'] === 'true',
        isThemeSwitcherEnabled: process.env['THEME_SWITCHER_ENABLED'] === 'true',
        isDiscoverBreadcrumbShortUrlsEnabled: process.env['HEADLESS_DISCOVER_BREADCRUMB_SHORT_URLS_ENABLED'] === 'true',
        isDeliveryToStoreCheckEnabled: process.env['HEADLESS_DELIVERY_TO_STORE_CHECK_ENABLED'] === 'true',
        isT2sConfigEnabled: process.env['HEADLESS_T2S_CONFIG_ENABLED'] === 'true',
        isReorderProductsEnabled: process.env['HEADLESS_REORDER_PRODUCTS_ENABLED'] === 'true',
        isPathnameOnlyEnabled: process.env['PATHNAME_ONLY_ENABLED'] === 'true',
        isShopTheFutureCustomerGroupsEnabled: process.env['SHOP_THE_FUTURE_CUSTOMER_GROUPS_ENABLED'] === 'true',
        isLoyaltyConfigEnabled: process.env['HEADLESS_LOYALTY_CONFIG_ENABLED'] === 'true',
    };
};

export const featureFlipping = createFeatureFlipping();
